const messageBarActions = {
  UPDATE: "updated",
  ADD: "added",
  DELETE: "deleted",
};

export { messageBarActions };
